import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes, css } from "styled-components";
import {
  countProductByStore,
  getAllspecialites,
  getAllStoresActive,
  getproductsbystore,
  productCountByStore,
} from "../../../shared/slice/restaurant/RestaurantService";
import {
  BaseURI,
  ClientURI,
  ImageURI,
  SaisieMode,
  store,
  TestMode,
} from "../../../shared";
import { setOrder } from "../../../shared/slice/order/OrderSlice";
import { resetPromo } from "../../../shared/slice/promos/PromosSlice";
import { useTranslation } from "react-i18next";
import { setModesModal } from "../../../shared/slice/ModalMode/ModalMode";
import AddressInput from "../../../components/AddressInput/AddressInput";
import { setScroll } from "../../../shared/slice/scroll/ScrollSlice";
import { useDispatch, useSelector } from "react-redux";
import { setProductCountForStore } from "../../../shared/slice/restaurant/RestaurantSlice";
import { getCountryByGPSOrIP } from "../../../utils/GeolocationService";
import { useSocket } from "../../../utils/socketContext";

const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
};

export default function StoreBySpeciality() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [coordinates, setCoordinates] = useState({ lat: null, lon: null });
  const [distances, setDistances] = useState({});
  const [location, setLocation] = useState(null);
  const [specialite1, setspecialite] = useState([]);
  const [AllStores, setAsllStores] = useState([]);
  const [FilteredRestaurants, setFilteredRestaurants] = useState([]);
  const [idSpecialite, setIdSpecialite] = useState([]);
  const [inputValue, setinputValue] = useState(false);
  const stores = useSelector((state) => state.restaurant.stores);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedStoreName, setSelectedStoreName] = useState("");
  const { socket, connected, joinStoreRoom,onStoreStatusUpdate,addListener } = useSocket();

  // Abonnement à toutes les rooms des magasins affichés pour écoute live du statut
  useEffect(() => {
    if (socket && connected && AllStores.length > 0) {
      AllStores.forEach((store) => {
        if (store._id) {
          joinStoreRoom(store._id);
          // Log chaque abonnement room pour debug
          console.log("[SOCKET] joinStoreRoom (list) pour:", store._id);
        }
      });
    }
  }, [socket, connected, AllStores]);
  // Veille via socket sur le changement de status des stores
  useEffect(() => {
    if (!socket || !connected) return;

    const cleanup = onStoreStatusUpdate((data) => {
      console.log("[SOCKET] Store status update received", data);
      
      setAsllStores(prevStores => 
        prevStores.map(store => 
          store._id === data.storeId 
            ? { ...store, active: data.active } 
            : store
        )
      );
      
      setFilteredRestaurants(prevRestaurants => 
        prevRestaurants.map(store => 
          store._id === data.storeId 
            ? { ...store, active: data.active } 
            : store
        )
      );
    });

    return () => {
      cleanup && cleanup();
    };
  }, [socket, connected, onStoreStatusUpdate]);

  
  const inputValue2 = (inputValue2) => {
    if (inputValue2 === "") {
      setinputValue(false);
    } else {
      setinputValue(true);
    }
  };

  useEffect(() => {
    if (inputValue === false) {
      setFilteredRestaurants(AllStores);
      setIdSpecialite([]);
      setLocation(null);
      setCoordinates({ lat: null, lon: null });
      setDistances({});
    }
  }, [inputValue]);

  const onSelectLocation = (selectedLocation) => {
    if (selectedLocation) {
      setCoordinates({
        lat: selectedLocation.value.lat,
        lon: selectedLocation.value.lon,
      });
      setLocation(selectedLocation);
      calculateDistanceFromInput(selectedLocation);
    }
  };

  const calculateDistanceFromInput = (location) => {
    if (location) {
      const distancesMap = {};
      FilteredRestaurants.forEach((store) => {
        const distance = calculateDistance(
          location.value.lat,
          location.value.lon,
          store.latitude,
          store.longitude
        ).toFixed(2);
        distancesMap[store._id] = distance;
      });
      setDistances(distancesMap);
      const filteredStoresWithDistance = FilteredRestaurants.filter(
        (store) => !distancesMap[store._id] || distancesMap[store._id] <= 60
      );
      const sortedStores = filteredStoresWithDistance
        .map((store) => ({
          ...store,
          distance: calculateDistance(
            store.latitude,
            store.longitude,
            coordinates.lat,
            coordinates.lon
          ),
        }))
        .sort((a, b) => a.distance - b.distance);
      setFilteredRestaurants(sortedStores);
    }
  };

  const calculateDistanceFromInput2 = (location, res) => {
    if (location) {
      const distancesMap = {};
      res.forEach((store) => {
        const distance = calculateDistance(
          location.value.lat,
          location.value.lon,
          store.latitude,
          store.longitude
        ).toFixed(2);
        distancesMap[store._id] = distance;
      });
      setDistances(distancesMap);
      const filteredStoresWithDistance = res.filter(
        (store) => !distancesMap[store._id] || distancesMap[store._id] <= 60
      );
      const sortedStores = filteredStoresWithDistance
        .map((store) => ({
          ...store,
          distance: calculateDistance(
            store.latitude,
            store.longitude,
            coordinates.lat,
            coordinates.lon
          ),
        }))
        .sort((a, b) => a.distance - b.distance);
      setFilteredRestaurants(sortedStores);
    }
  };
  useEffect(() => {
  const cleanup = addListener('store_status_update', (data) => {
    console.log('STATUS UPDATE DATA:', data);
    
    setAsllStores(prev => prev.map(store => 
      store._id === data.storeId ? { ...store, active: data.active } : store
    ));
    
    setFilteredRestaurants(prev => prev.map(store => 
      store._id === data.storeId ? { ...store, active: data.active } : store
    ));
  });

  return cleanup;
}, [addListener]);

  useEffect(() => {
    if (location) {
      calculateDistanceFromInput(location);
    }
  }, [location]);

  useEffect(() => {
    const fetchAllspecialites = async () => {
      try {
        const speaRes = await getAllspecialites();
        if (speaRes.length > 0) {
          setspecialite(speaRes);
          const AllStores = await getAllStoresActive();

          if (TestMode && SaisieMode) {
            throw new Error(
              "Error: Both TestMode and SaisieMode cannot be true."
            );
          }

          let AllStoreInModeTest = [];

          if (!TestMode && !SaisieMode) {
            AllStoreInModeTest = AllStores.filter(
              (store) => store.modetest === false && store.integration === false
            );
          } else if (TestMode && !SaisieMode) {
            AllStoreInModeTest = AllStores.filter(
              (store) => store.modetest === true && store.integration === false
            );
          } else if (!TestMode && SaisieMode) {
            AllStoreInModeTest = AllStores.filter(
              (store) => store.modetest === false && store.integration === true
            );
          }

          let filteredByCountry = AllStoreInModeTest;
          try {
            const locationData = await getCountryByGPSOrIP();
            const detectedCountryCode = locationData?.country_code || null;
            if (detectedCountryCode) {
              filteredByCountry = AllStoreInModeTest.filter(
                (store) =>
                  store.detailedAddress &&
                  store.detailedAddress.country_code &&
                  store.detailedAddress.country_code.toLowerCase() ===
                    detectedCountryCode
              );
              if (filteredByCountry.length === 0) {
                filteredByCountry = AllStoreInModeTest;
              }
            }
          } catch (err) {
            filteredByCountry = AllStoreInModeTest;
          }

          setAsllStores(filteredByCountry);
          setFilteredRestaurants(filteredByCountry);
        }
      } catch (err) {
        console.error("Error:", err);
      }
    };
    fetchAllspecialites();
  }, [TestMode, SaisieMode]);

  const formatTimeDifference = (createdAt) => {
    const now = new Date();
    const createdDate = new Date(createdAt);
    const diffInMs = now - createdDate;

    const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (diffInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));

    let timeStr = "";
    if (days > 0) timeStr += `${days} ${t("Days")}`;
    if (hours > 0) timeStr += ` ${t("and")} ${hours} ${t("Hours")}`;
    if (minutes > 0 && days === 0 && hours === 0)
      timeStr += ` ${t("and")} ${minutes} ${t("Minutes")}`;

    return timeStr;
  };

  const fetchData = async () => {
    try {
      let filtered = [];
      if (idSpecialite.length > 0) {
        filtered = AllStores.filter((restaurant) =>
          idSpecialite.some((id) => restaurant.specialites.includes(id))
        );
      } else {
        filtered = [...AllStores];
      }
      const uniqueFiltered = filtered.filter(
        (store, index, self) =>
          index === self.findIndex((s) => s._id === store._id)
      );
      const distanceFiltered = uniqueFiltered.filter(
        (store) => !distances[store._id] || distances[store._id] <= 60
      );
      setFilteredRestaurants(distanceFiltered);
      if (location !== null) {
        calculateDistanceFromInput2(location, distanceFiltered);
      }
    } catch (err) {
      console.error("Error", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [idSpecialite]);

    const getIntoStore = (storeSlug, isActive, storeName) => {
    if (!isActive) {
      setSelectedStoreName(storeName);
      setShowPopup(true);
      return;
    }
    navigateToStore(storeSlug);
  };
  
  const navigateToStore = (storeSlug) => {
    store.dispatch(setScroll({ scroll: 1 }));
    store.dispatch(setModesModal({ modesModal: true }));
    store.dispatch(setOrder({ order: [] }));
    store.dispatch(resetPromo());
    navigate(`/${storeSlug}`);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedStoreName("");
  };

  const isOpenNow = (storeRes) => {
    if (!storeRes.active) return false;

    const { openingdate } = storeRes;
    const currentTime = new Date();
    const currentDay = currentTime.toLocaleString("en-US", { weekday: "long" });
    const currentTimeString = currentTime.toLocaleTimeString("en-US", {
      hour12: false,
    });
    return openingdate.some(({ shifts, jour }) => {
      const { start, end } = shifts;
      const isOpen = jour[currentDay]?.isOpen;
      if (!isOpen) return false;
      if (end < start) {
        const adjustedCurrentTime = new Date(currentTime);
        adjustedCurrentTime.setDate(adjustedCurrentTime.getDate() - 1);
        const adjustedCurrentTimeString =
          adjustedCurrentTime.toLocaleTimeString("en-US", { hour12: false });
        return (
          currentTimeString >= start ||
          currentTimeString <= end ||
          adjustedCurrentTimeString >= start
        );
      } else {
        return currentTimeString >= start && currentTimeString <= end;
      }
    });
  };
  const handleSpecialiteClick = (id) => {
    if (idSpecialite.includes(id)) {
      setIdSpecialite(idSpecialite.filter((item) => item !== id));
    } else {
      setIdSpecialite([...idSpecialite, id]);
    }
  };

  const dispatch = useDispatch();
  const productCounts = useSelector((state) => state.restaurant.productCounts);
  const [loadingCounts, setLoadingCounts] = useState({});

  const fetchProductCountForStore = async (storeId) => {
    if (productCounts[storeId] !== undefined || loadingCounts[storeId]) {
      return;
    }

    setLoadingCounts((prev) => ({ ...prev, [storeId]: true }));

    try {
      const response = await productCountByStore(storeId);
      const count = response?.count || response?.data?.count || 0;

      dispatch(
        setProductCountForStore({
          storeId,
          count,
        })
      );
    } catch (error) {
      console.error(
        `Failed to fetch product count for store ${storeId}:`,
        error
      );
      dispatch(
        setProductCountForStore({
          storeId,
          count: "N/A",
        })
      );
    } finally {
      setLoadingCounts((prev) => ({ ...prev, [storeId]: false }));
    }
  };

  useEffect(() => {
    if (FilteredRestaurants.length > 0) {
      FilteredRestaurants.forEach((store) => {
        fetchProductCountForStore(store._id);
      });
    }
  }, [FilteredRestaurants]);

  const StoreClosedPopup = ({ isOpen, onClose, storeName }) => {
    if (!isOpen) return null;

    return (
      <PopupOverlay onClick={onClose}>
        <PopupContainer onClick={(e) => e.stopPropagation()}>
          <PopupIcon>🍽️</PopupIcon>
          <PopupTitle>
            {store.active
              ? "Restaurant temporairement fermé"
              : "Restaurant indisponible"}
          </PopupTitle>
          <PopupMessage>
            <strong>{storeName}</strong> n'est pas disponible en ce moment.
            <br />
            Mais ne vous inquiétez pas ! Nous avons plein d'autres délicieuses
            options qui vous attendent !
            <br />
            <br />
            🌟{" "}
            <em>Votre prochaine découverte culinaire est à portée de clic !</em>
          </PopupMessage>
          <PopupButton onClick={onClose}>
            Découvrir d'autres restaurants
          </PopupButton>
        </PopupContainer>
      </PopupOverlay>
    );
  };

  return (
    <div style={{ margin: "0px", backgroundColor: "#F8F9FA" }}>
      <AdressInp
        style={{
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <div
          style={{
            width: "85%",
            alignItems: "center",
            justifySelf: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <StyledHeading>{t("slogan.main")}</StyledHeading>
          <StyledSubHeading>{t("slogan.sub")}</StyledSubHeading>

          <AddressInput
            width={"43%"}
            onSelectLocation={onSelectLocation}
            calculateDistanceFn={calculateDistanceFromInput}
            inputValue2={inputValue2}
          />
        </div>
      </AdressInp>
      <StickyContainer>
        {specialite1 &&
          specialite1.map((sp, index) => (
            <SpecialityItem
              key={index}
              isActive={idSpecialite.includes(sp._id)}
              onClick={() => handleSpecialiteClick(sp._id)}
            >
              <H1Styled>{sp.emoji}</H1Styled>
              <span>{sp.name}</span>
            </SpecialityItem>
          ))}
      </StickyContainer>
      <StoresContainer>
        {FilteredRestaurants.length === 0 ? (
          <p>No stores found</p>
        ) : (
          FilteredRestaurants.map((store) =>
            !distances[store._id] || distances[store._id] <= 60 ? (
              <StoreInfoContainer
                key={store._id}
                onClick={() =>
                  getIntoStore(
                    store.slug,
                    store.active,
                    store.name
                  )
                }
                isActive={store.active}
                style={{ position: "relative" }}
              >
                <img
                  style={{ borderRadius: "16px", height: "11rem" }}
                  src={`${ImageURI}/combined-uploads/${store.StoreBanner}`}
                  alt="Company cover"
                />
                <LogoNameContainer>
                  <StoreLogo
                    src={`${ImageURI}/combined-uploads/${store.logo}`}
                    alt="Store Logo"
                  />
                  <HCompanyName>{store.name}</HCompanyName>
                </LogoNameContainer>
                <div
                  style={{
                    width: "100px!important",
                    display: "flex",
                    marginTop: "10px",
                    alignContent: "center",
                  }}
                >
                  <Adressp>
                    {store.detailedAddress?.house_number &&
                    store.detailedAddress?.road &&
                    store.detailedAddress?.city &&
                    store.detailedAddress?.postcode
                      ? `${store.detailedAddress.house_number} ${store.detailedAddress.road}, ${store.detailedAddress.postcode} ${store.detailedAddress.city}`
                      : store.address}
                  </Adressp>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <DistanceLabel>
                    {distances[store._id] > 0 &&
                      `${(distances[store._id] * 3.5) | 0} min`}{" "}
                    {distances[store._id] > 0 && t("away")}
                  </DistanceLabel>
                  <ActiveStatus>
                    <h6>{isOpenNow(store) ? t("Open 🟢") : t("Closed 🔴")}</h6>
                  </ActiveStatus>
                </div>
                {SaisieMode === true && (
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      backgroundColor: "rgba(2, 87, 22, 0.8)",
                      padding: "5px 10px",
                      borderRadius: "0px 16px 0px 0px",
                      fontSize: "12px",
                      boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 5px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      color: "rgba(255, 255, 255, 0.8)",
                    }}
                  >
                    <div>
                      <div>
                        <strong>{t("Created From :")}</strong>{" "}
                        {formatTimeDifference(store.createdAt)}
                      </div>
                    </div>
                    <div>
                      <strong>{t("Products :")}</strong>{" "}
                      {loadingCounts[store._id]
                        ? "..."
                        : productCounts[store._id] !== undefined
                        ? productCounts[store._id]
                        : "N/A"}
                    </div>
                  </div>
                )}
                <Separator />
              </StoreInfoContainer>
            ) : null
          )
        )}
      </StoresContainer>

      <StoreClosedPopup
        isOpen={showPopup}
        onClose={closePopup}
        storeName={selectedStoreName}
      />
    </div>
  );
}

const Separator = styled.hr`
  border: 0px solid gray;
  @media (max-width: 768px) {
    border: 0.1rem solid gray;
  }
`;
const DistanceLabel = styled.p`
  position: relative;
  color: #777;
  font-size: 1rem !important;
  @media (max-width: 768px) {
    font-size: 0.7rem !important;
  }
`;

const AdressInp = styled.div`
  background: linear-gradient(
    45deg,
    rgba(235, 23, 0, 1) 0%,
    rgba(238, 51, 31, 1) 33%,
    rgba(240, 65, 46, 1) 65%,
    rgba(235, 23, 0, 1) 100%
  );
  height: 600px;
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 80%;
    height: 360px;
  }
`;

const moveAnimationImageWithPause = keyframes`
  0%, 12.5% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(15deg);
  }
  37.5% {
    transform: rotate(-15deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const H1Styled = styled.h1`
  position: relative; /* Required for positioning the pseudo-element */
`;
const StickyContainer = styled.div`
  padding-top: 12px;
  margin-bottom: 40px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

  display: flex;
  overflow-x: auto;
  position: -webkit-sticky; /* For Safari */
  position: sticky;
  top: 60px; /* Adjust this to match the height of your fixed Container */
  background-color: white; /* Ensure it has a background color */
  z-index: 999; /* Ensure it appears above other elements */
  white-space: nowrap;
  max-height: 300px;
  @media (min-width: 676px) {
    justify-content: center;
  }
  user-select: none;
`;

const SpecialityItem = styled.div`
  margin: 5px 20px;
  cursor: pointer;
  color: ${({ isActive }) => (isActive ? "rgb(235, 23, 0)" : "inherit")};
  font-family: ${({ isActive }) =>
    isActive ? "QuicksandBold!important" : "inherit"};
  margin-top: ${({ isActive }) => (isActive ? "-5px" : "20px")};
  text-align: center;
  position: relative; /* Required for positioning the pseudo-element */

  h1 {
    animation: ${({ isActive }) =>
      isActive
        ? css`
            ${moveAnimationImageWithPause} 0.8s ease-in-out infinite
          `
        : "none"};
    font-size: ${({ isActive }) => (isActive ? "36px" : "18px")};
    filter: ${({ isActive }) =>
      isActive ? "drop-shadow(-2px 18px 8px rgba(0, 0, 0, 0.3))" : "inherit"};
    position: relative; /* Required for positioning the pseudo-element */
  }

  span {
    font-size: ${({ isActive }) => (isActive ? "1rem" : "0.85rem")};
  }

  /* Add the colored circle behind the icon */
  h1::before {
    content: "";
    display: ${({ isActive }) =>
      isActive ? "block" : "none"}; /* Only show when active */
    width: 50px; /* Adjust the size as needed */
    height: 50px; /* Adjust the size as needed */
    background-color: rgba(
      235,
      23,
      0,
      0.5
    ); /* Change color and opacity as needed */
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1; /* Ensure it is behind the icon */
  }
`;

const StoresContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  min-width: 100%;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  min-height: 300px;
  @media (min-width: 768px) {
    margin: 10px;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    max-width: 100%;
    justify-content: center;
    align-items: center;
  }
  margin-bottom: 60px;
`;

const StoreLogo = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 60px;
  margin-right: 20px;
  margin-top: -50px;

  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
  }
`;

const Adressp = styled.p`
  margin-bottom: 5px;
  margin-top: 20px;
  text-align: center;
  font-size: 0.7rem !important;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 768px) {
    font-size: 0.8rem !important;
    -webkit-line-clamp: 3; /* Show more lines on mobile */
  }
`;

const ActiveStatus = styled.div`
  text-align-last: right;
  font-size: 1rem !important;
  position: relative;
  top: 5px;
  right: 5px;
`;

const StoreInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 400px;
  min-width: 400px;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.7)};

  ${({ isActive }) =>
    !isActive &&
    `
    position: relative;
    &::after {
      content: '🔒 Temporairement fermé';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255, 107, 107, 0.9);
      color: white;
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 0.9rem;
      font-weight: bold;
      white-space: nowrap;
      z-index: 2;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
  `}

  &:hover {
    transform: ${({ isActive }) =>
      isActive ? "translateY(-5px)" : "scale(1.02)"};
    box-shadow: ${({ isActive }) =>
      isActive
        ? "0 6px 12px rgba(0, 0, 0, 0.2)"
        : "0 8px 16px rgba(255, 107, 107, 0.3)"};
  }

  @media (max-width: 767px) {
    max-width: 100% !important;
    min-width: 100% !important;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 50%;
  }
`;

// 4. Ajouter un styled-component pour l'overlay (optionnel)
const InactiveOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  z-index: 1;

  &::after {
    content: "Store fermé";
  }
`;

const LogoNameContainer = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: flex-end;
`;

const HCompanyName = styled.span`
  font-size: 1rem;
  margin-left: 0.5rem;
  text-align: center;
  color: #333;

  @media (max-width: 767px) {
    font-size: 1.3rem;
  }
`;

const StyledHeading = styled.h1`
  margin-bottom: 0px;
  color: #fff;
  font-size: 3rem;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const StyledSubHeading = styled.h3`
  color: #fff;
  font-size: 1.6rem;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

// Animation pour la popup
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const slideIn = keyframes`
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

// Styled Components pour la popup
const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(
    0,
    0,
    0,
    0.3
  ); /* Réduire l'opacité pour voir l'arrière-plan */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ${fadeIn} 0.3s ease-out;
  backdrop-filter: blur(
    3px
  ); /* Ajouter un léger flou pour l'effet professionnel */
`;

const PopupContainer = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  text-align: center;
  animation: ${slideIn} 0.4s ease-out;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4); /* Ombre plus prononcée pour faire ressortir la popup */
  position: relative;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.2); /* Bordure subtile pour définir la popup */

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent,
      rgba(255, 255, 255, 0.1),
      transparent
    );
    transform: rotate(45deg);
    animation: shimmer 2s infinite;
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-100%) translateY(-100%) rotate(45deg);
    }
    100% {
      transform: translateX(100%) translateY(100%) rotate(45deg);
    }
  }
`;

const PopupIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1rem;
  animation: bounce 2s infinite;

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }
`;

const PopupTitle = styled.h2`
  color: white;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: bold;
`;

const PopupMessage = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
`;

const PopupButton = styled.button`
  background: linear-gradient(45deg, #ff6b6b, #ff8e53);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
  }

  &:active {
    transform: translateY(0);
  }
`;
